export default __webpack_public_path__ + "static/media/misc-closetC-480w.522ffdcb.webp";